// extracted by css-extract-rspack-plugin
export default {"root":"_3b7VjZo5yIt8e_n27XFywT","header":"_6mm-g5WGCgvbqw7vZLikO","content":"DvD76POUKlsMOx-r2jqiv"};